import React, { useContext, useState } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import { DELETE_SUBJECT } from "../../Schema/Subject";
import { BiMinusCircle } from "react-icons/bi"; 

export default function DeleteSubject({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { t } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [deleteSubject] = useMutation(DELETE_SUBJECT, {
    onCompleted: ({ deleteSubject }) => {
      // console.log("deleteSubject :", deleteSubject);
      setLoading(false);
      if (deleteSubject?.isSuccess === true) {
        setAlert(true, "success", deleteSubject?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteSubject?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteSubject({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {t("modal_title_delete_subject")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              {t("thead_do_you_want_to_delete_this_data")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {loading ? (
              <Button className="btn-delete" fullWidth>
                {t("loading")}
              </Button>
            ) : (
              <Button className="btn-delete" fullWidth onClick={handleDelete}>
                {t("delete")}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
